import { cn } from '@ui/atoms/utils/utils';
import React from 'react';
import BondSectionTemplate from './BondSectionTemplate';
import LoginCTA from './LoginCTA';
import texts from '@components/BondDirectoryFeature/feature/BondDetails/en.json';
import PropTypes from 'prop-types';

const KeyInvestmentHighlightsMask = ({ onButtonClick }) => {
    return (
        <BondSectionTemplate
            title={texts.KeyInvestmentHighlights}
            className="pb-6 border-b-0"
        >
            <section className="flex flex-col gap-4 xl:max-w-[744px] w-full relative">
                {/* Masked Content */}
                <div
                    className={cn(
                        `flex flex-col gap-6 items-center justify-center w-full rounded-b-lg `
                    )}
                >
                    <div className="flex flex-col w-full gap-2">
                        <div className="w-full h-3 bg-gray-100 rounded" />
                        <div className="w-full h-3 bg-gray-100 rounded" />
                        <div className="w-full h-3 bg-gray-100 rounded" />
                        <div className="w-1/2 h-3 bg-gray-100 rounded" />
                    </div>
                    <div className="flex flex-col w-full gap-2">
                        <div className="w-full h-3 bg-gray-100 rounded " />
                        <div className="w-full h-3 bg-gray-100 rounded " />
                        <div className="w-full h-3 bg-gray-100 rounded " />
                        <div className="w-1/2 h-3 bg-gray-100 rounded " />
                    </div>
                    <div className="inline-flex flex-col w-full gap-2">
                        <div className="w-full h-3 bg-gray-100 rounded" />
                        <div className="w-full h-3 bg-gray-100 rounded" />
                        <div className="w-1/2 h-3 bg-gray-100 rounded" />
                    </div>
                </div>

                <LoginCTA
                    title={texts.LearnMore}
                    description={texts.LoginNowToDive}
                    float
                    buttonText={texts.LoginNow}
                    onButtonClick={onButtonClick}
                    className={'hidden xl:inline-flex'}
                />
            </section>
        </BondSectionTemplate>
    );
};

KeyInvestmentHighlightsMask.propTypes = {
    onButtonClick: PropTypes.func.isRequired,
};

export default KeyInvestmentHighlightsMask;
